
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / devices","xmlns":"http://www.w3.org/2000/svg","width":"19.507","height":"19.507"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M2.25 19.507A2.253 2.253 0 010 17.257v-8a2.255 2.255 0 011.557-2.145V2.75A2.75 2.75 0 014.14.005L4.307 0h10.449A2.751 2.751 0 0117.5 2.583l.005.167V9h.25a1.752 1.752 0 011.75 1.75v6a1.752 1.752 0 01-1.75 1.75h-3a1.752 1.752 0 01-1.751-1.75v-3.245H9.5v1.5h1.251a.75.75 0 01.1 1.493l-.1.006H9.5v.751a2.252 2.252 0 01-2.25 2.25zM1.5 9.253v8a.751.751 0 00.75.75h5a.751.751 0 00.75-.746v-8a.751.751 0 00-.751-.75h-5a.751.751 0 00-.749.746zm13.005 7.5a.251.251 0 00.25.251h3a.25.25 0 00.25-.251v-6a.25.25 0 00-.25-.25h-3a.251.251 0 00-.25.25v6zm-1.5-4.751v-1.248A1.753 1.753 0 0114.756 9h1.251V2.75a1.251 1.251 0 00-1.123-1.244l-.128-.006H4.307a1.252 1.252 0 00-1.244 1.123l-.006.128V7h4.2A2.253 2.253 0 019.5 9.253v2.752z","fill":"#011936"}})])
          )
        }
      }
    